/**
 * @module pages/ScreenPage
 * @description Ballroom projection view: the edition's progress panel full-screen with a
 * gratitude ribbon of recent donors (first names only; anonymous donors are
 * shown as "A friend of AFJ"). Stories rotate behind the meter.
 */
import { useEffect, useState } from "react";
import { ChallengePanel } from "../components/MatchMeter";
import { BrandLockup } from "../components/Brand";
import { usePledges, usePublishedCards } from "../data";
import { CAMPAIGN } from "../config/campaign";
import { assetUrl } from "../lib/assetUrl";

const ROTATE_MS = 8000;

export function ScreenPage() {
    const pledges = usePledges();
    const cards = usePublishedCards();
    const [i, setI] = useState(0);

    useEffect(() => {
        const t = window.setInterval(() => setI((n) => n + 1), ROTATE_MS);
        return () => window.clearInterval(t);
    }, []);

    const card = cards.length ? cards[i % cards.length] : null;
    const names = pledges.slice(0, 12).map((p) => (p.anonymous ? "A friend of AFJ" : p.name.split(" ")[0]));

    return (
        <div className="screen">
            {card && <img key={card.id} className="screen-bg" src={assetUrl(card.image.src)} alt="" />}
            <div className="screen-inner">
                <BrandLockup variant="horizontal" className="screen-lockup" />
                <p className="pc-script screen-script">{CAMPAIGN.campaignName}.</p>
                <ChallengePanel variant="screen" />
                {card && (
                    <p className="screen-story">
                        <strong>{card.statValue.replace(/\n/g, " ")}</strong> {card.statLabel.toLowerCase()} · {card.title}
                    </p>
                )}
                {names.length > 0 && <p className="screen-thanks">Thank you, {names.join(" · ")}</p>}
            </div>
        </div>
    );
}
